"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgApiLink(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "1 0 22 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M22 4a1 1 0 011 1v14a1 1 0 01-1 1H2a1 1 0 01-1-1V5a1 1 0 011-1h20zM7.419 7H5.58L3 16h2.023l.465-1.761h2.024L7.977 16H10L7.419 7zm6.277 0H11v9h2.016v-2.931h.79c2.016 0 3.194-.836 3.194-3.009C17 7.604 15.761 7 13.696 7zM20 7h-2v9h2V7zM6.518 10l.468 2h-.972l.468-2h.036zm7.144-1c1 0 1.338.246 1.338.995C15 10.71 14.662 11 13.662 11H13V9h.662z" })));
}
exports.default = tombacIcon_1.default('ApiLink')(SvgApiLink);
//# sourceMappingURL=ApiLink.js.map